// Automatisch gegenereerd door tools/generate-dto.mjs — niet handmatig wijzigen.
// Bij herGeneratie worden imports, constructor-body en static create bewaard.

import { IUserData, userData } from 'src/app/features/user/models/user-data';
import { ILevelGeneralDto } from 'src/app/infrastructure/models/level-general-dto';
import { IImageBoxDto } from './image-box-dto.g';

export const userDto = {
    guid: 'guid',
    applicationName: 'applicationName',
    firstName: 'firstName',
    lastName: 'lastName',
    correspondenceName: 'correspondenceName',
    email: 'email',
    inactive: 'inactive',
    deleted: 'deleted',
    photoBoxDto: 'photoBoxDto',
} as const;

export type TUserDto = (typeof userDto)[keyof typeof userDto];

export const userDtoConstraints = {
    applicationName: { maxLength: 50 },
    firstName: { maxLength: 50 },
    lastName: { maxLength: 50 },
    correspondenceName: { maxLength: 100 },
} as const;

export type TUserDtoConstraints = typeof userDtoConstraints;

export interface IUserDto extends ILevelGeneralDto {
    [userDto.guid]: string | null;
    [userDto.applicationName]: string | null;
    [userDto.firstName]: string | null;
    [userDto.lastName]: string | null;
    [userDto.correspondenceName]: string | null;
    [userDto.email]: string | null;
    [userDto.inactive]: boolean | null;
    [userDto.deleted]: boolean | null;
    [userDto.photoBoxDto]: IImageBoxDto | null;
}

export class UserDto
    implements IUserDto
{
    [userDto.guid]: string | null = null;
    [userDto.applicationName]: string | null = null;
    [userDto.firstName]: string | null = null;
    [userDto.lastName]: string | null = null;
    [userDto.correspondenceName]: string | null = null;
    [userDto.email]: string | null = null;
    [userDto.inactive]: boolean | null = null;
    [userDto.deleted]: boolean | null = null;
    [userDto.photoBoxDto]: IImageBoxDto | null = null;

    private constructor(
        modelData: IUserData,
    ) {
        this[userDto.guid] = modelData[userData.guid];
        this[userDto.applicationName] = modelData[userData.applicationName];
        this[userDto.firstName] = modelData[userData.firstName];
        this[userDto.lastName] = modelData[userData.lastName];
        this[userDto.correspondenceName] = modelData[userData.correspondenceName];
        this[userDto.email] = modelData[userData.email];
        this[userDto.inactive] = modelData[userData.inactive];
        this[userDto.deleted] = modelData[userData.deleted];
    }

    static create(modelData?: IUserData | null): IUserDto | null {
        return modelData ? new UserDto(modelData) : null;
    }
}
